import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';
import parse from 'html-react-parser';

const OtherServicesSection = () => {
    const { language } = useLanguage();
    const t = translations[language].servicesList;

    return (
        <section id="id-section-services" className="section-services" data-aos="fade-up">
            <div className="services-left">
                <h1 className="services-ttitle">
                    {t.title_part1}
                    <span className="text-span-4">{t.title_highlight}</span>
                </h1>
                <p className="services-description">{t.description}</p>
            </div>
            <div className="services-rigth">
                <div className="w-layout-grid content-card">
                    {t.items.map((item, index) => (
                        <div className="item-card" key={index}>
                            <img src={item.icon} width={28} alt={item.title} className="image-card-service" />
                            <h1 className="card-title-service">{parse(item.title)}</h1>
                            <p className="card-description-service">{parse(item.text)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OtherServicesSection;
